export default  [

  {
    key: "index",
    label: "#",
    sortable: true
  },

  {
    key: "date",
    label: "Date",
    sortable: true
  },

  {
    key: "total_planned_lifts",
    label: "total planned lifts",
    sortable: true
  },

  {
    key: "total_actually_lifts",
    label: "total actually lifts",
    sortable: true
  },


  {
    key: "total_planned_washes",
    label: "total planned washes",
    sortable: true
  },

  {
    key: "total_actually_washes",
    label: "total actually washes",
    sortable: true
  },

  {
    key: "total_planned_sweep",
    label: "total planned sweep",
    sortable: true
  },

  {
    key: "total_actually_sweep",
    label: "total actually sweep",
    sortable: true
  },

  {
    key: "total_percentage",
    label: "percent",
    sortable: true
  },
]